import { Routes } from '@angular/router';

export const AppRoutes: Routes
= [
  {
    path: '',
    loadComponent: () => import('./modules/home/home.component').then(m => m.HomeComponent),
  },
  {
    path: 'choose',
    loadComponent: () => import('./modules/choose/choose.component').then(m => m.ChooseComponent),
  },

  {
    path: '**',
    loadComponent: () => import('./modules/page-not-found/page-not-found.component').then(m => m.PageNotFoundComponent),
  },
];
